import { Util } from './../_classes/util';
import { Diaria } from './../_classes/diaria';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Component, OnInit, ViewChild } from '@angular/core';

const OBS: string[] = [
  'Custeado pelo CSJT',
  'Pago pelo órgão solicitante',
  'Despesa ordinária',
];

const DESTINO: string[] = [
  'Sãao sdf asdfasdf asdfa - SP',
  'Brasílsdfasdfasdfaia - DF',
  'asdfasdf - PR',
  'Campo asdfasdf - MS',
];

const MOTIVO: string[] = [
  'Para  asdfasdf curso',
  'asdfasdf de congresso',
  'Para composdfasr equipe',
];

@Component({
  selector: 'app-diaria',
  templateUrl: './diaria.component.html',
  styleUrls: ['./diaria.component.scss'],
})
export class DiariaComponent implements OnInit {
  displayedColumns: string[] = [
    'periodo',
    'qtde',
    'valor',
    'obs',
    'ato',
    'destino',
    'motivo',
  ];

  dataSource: MatTableDataSource<Diaria>;

  @ViewChild(MatPaginator, /* TODO: add static flag */ { static: true })
  paginator: MatPaginator;
  @ViewChild(MatSort, /* TODO: add static flag */ { static: true }) sort: MatSort;

  constructor() {
    // Create 100 users
    const lista = Array.from({ length: 10 }, (_, k) => criar(k + 1));

    // Assign the data to the data source for the table to render
    //console.log(lista);
    this.dataSource = new MatTableDataSource(lista);
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}

function criar(pId: number): Diaria {
  const d: Diaria = new Diaria();
  d.id = pId;
  d.dataI = new Date();
  d.dataF = Util.somarDias(d.dataI, 182); //154
  d.qtde = Math.floor(Math.random() * 5);
  d.valor = Math.floor(Math.random() * 2000);
  d.ato = 'Ato ' + Math.floor(Math.random() * 1000);
  d.observacoes = OBS[Math.round(Math.random() * (OBS.length - 1))];
  d.destino = DESTINO[Math.round(Math.random() * (DESTINO.length - 1))];
  d.motivo = MOTIVO[Math.round(Math.random() * (MOTIVO.length - 1))];
  return d;
}
